import React, { Component, Fragment } from 'react';
import { Grid, Modal, Header, Button, Select, Input } from 'semantic-ui-react';
import ReactTable from 'react-table';

import { toastError } from 'Common/ToastHelper';

export default class MappingModal extends Component {
  static defaultProps = {
    options: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      sourceValue: '',
      mappedValue: '',
      finalMappedValues: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { finalMappedValues: prevMappedValues } = prevProps;
    const { finalMappedValues } = this.props;

    if (prevMappedValues !== finalMappedValues) {
      this.setState({ finalMappedValues });
    }
  }

  changeSourceValue = e => {
    this.setState({ sourceValue: e.target.value });
  };

  clearData = () => {
    this.setState({ mappedValue: '', sourceValue: '' });
  };

  changeMappedValue = (event, { value }) => {
    this.setState({ mappedValue: value });
  };

  removeData = () => {
    let removedList = [];
    let filterList = this.state.finalMappedValues;
    removedList = filterList.filter(
      x =>
        !(
          x.InternalField === String(this.state.mappedValue) &&
          x.ExternalField === String(this.state.sourceValue)
        )
    );
    this.props.saveData(removedList);
    this.setState({
      finalMappedValues: removedList,
      sourceValue: '',
      mappedValue: '',
    });
  };

  onRowClick = (state, rowInfo, column, instance) => {
    return {
      onClick: e => {
        this.setState({
          sourceValue: rowInfo.original.ExternalField,
          mappedValue: rowInfo.original.InternalField,
        });
      },
    };
  };

  addData = () => {
    const { sourceValue, mappedValue, finalMappedValues = [] } = this.state;
    const { dataMapped, type, saveData } = this.props;

    if (sourceValue === '' || mappedValue === '') {
      toastError('Source and Mapped Values are required');
      return;
    }

    let { [mappedValue]: internalFieldValue } = dataMapped;
    let mappedRepetationValue = finalMappedValues.find(
      v =>
        v.ExternalField.toString().toLowerCase() ===
        sourceValue.toString().toLowerCase()
    );

    if (mappedRepetationValue) {
      toastError(`The source value ${sourceValue} can only be mapped once!`);
      return;
    }

    const totalValuesList = [
      {
        ExternalField: sourceValue,
        InternalField: String(mappedValue),
        MappingTypeId: type,
        mappedValue: internalFieldValue,
      },
      ...finalMappedValues,
    ];

    this.setState({
      finalMappedValues: totalValuesList,
      sourceValue: '', // is this value is stored in redux and the state? remove from state
      mappedValue: '',
    });
    saveData(totalValuesList);
  };

  render() {
    const { sourceValue, mappedValue, finalMappedValues } = this.state;
    const { showEditModal, onClose, headerValue, options } = this.props;

    return (
      <Modal
        open={showEditModal}
        onClose={() => {
          onClose();
          this.clearData();
        }}
        size="small"
        closeIcon
      >
        <Header content={headerValue} />
        <Modal.Description>
          <Fragment>
            <ReactTable
              data={finalMappedValues}
              getTrProps={this.onRowClick}
              resizable={false}
              showPagination={false}
              defaultPageSize={25}
              style={{
                height: '200px',
                marginBottom: '30px',
                textAlign: 'center',
              }}
              className="-striped -highlight"
              columns={[
                {
                  Header: 'Source Value:',
                  accessor: 'ExternalField',
                },
                {
                  Header: 'Mapped Value:',
                  accessor: 'mappedValue',
                },
              ]}
            />
            <Grid columns={2} textAlign="center" padded="vertically">
              <Grid.Row>
                <Grid.Column>
                  <label>
                    Source Value
                    <div>
                      <Input
                        maxLength={30}
                        value={sourceValue}
                        onChange={this.changeSourceValue}
                      />
                    </div>
                  </label>
                </Grid.Column>
                <Grid.Column>
                  <label>
                    Mapped Value
                    <div>
                      <Select
                        options={options}
                        onChange={this.changeMappedValue}
                        value={mappedValue}
                      />
                    </div>
                  </label>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Fragment>
        </Modal.Description>
        <Modal.Actions style={{ textAlign: 'center' }}>
          <Button onClick={this.addData}>Add</Button>
          <Button onClick={this.clearData}>Clear</Button>
          <Button onClick={this.removeData}>Remove</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/importstudents/MappingModal.js